<template>
    <!-- 转发 -->
  <div class="my-transpond" @click="hanldeClick">
    <div class="line"></div>
    <div class="icon-procedure">
        <div class="transpond-box">
            <p class="title">请点击右上角</p>
            <img src="../../../assets/images/article/three-points.png" alt="">
        </div>
    </div>
  </div>
</template>

<script>
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  name: 'transpond',
  data() {
    return {

    }
  },
  methods: {
    hanldeClick() {
      this.$emit('handlecanel')
    }
  }
}
export default withRouteTracking(UserProfile)
</script>

<style lang="less" scoped>
.my-transpond{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    background: rgba(0,0,0,0.5);
    .line{
        background: url('../../../assets/images/article/line.png') no-repeat center center / 100% 100%;
        width: 83px;
        height: 110px;
        position: absolute;
        right: 17px;
        top: 10px;
    }
    .icon-procedure{
        background: #fff url('../../../assets/images/article/icon-procedure.png') no-repeat center center / 100% 100%;
        width: 320px;
        height: 270px;
        position: absolute;
        top: 130px;
        left: 26px;
      border-radius: 10px;
        .transpond-box{
            position: relative;
            top: 54px;
            width: 40%;
            display: flex;
            align-items: center;
            margin: 0 auto;
            .title{
                font-family: Source Han Sans CN, Source Han Sans CN;
                font-weight: 400;
                font-size: 14px;
                color: #000;
                line-height: 20px;
                margin-right: 8px;
            }
            img{
                margin-top: 2px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/article/components/transpond.vue